/* Keep image requests out of the template parser; fetch near the actual rendered position. */
(() => {
  const bound = new WeakSet(), ready = new WeakSet();
  function load(img) {
    const src = img.getAttribute('data-mp2-src');
    if (!src || src.includes('{{')) return;
    if (img.getAttribute('src') !== src) img.setAttribute('src',src);
  }
  const io = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting}) => {
    if (!isIntersecting) return; ready.add(target); load(target); io.unobserve(target);
  }),{rootMargin:'700px 0px'});
  function bind(root) {
    const images = root.matches?.('img[data-mp2-src]') ? [root] : [...(root.querySelectorAll?.('img[data-mp2-src]') || [])];
    for(const img of images) { if(bound.has(img) || img.closest('x-dc')) continue; bound.add(img); io.observe(img); }
  }
  bind(document);
  new MutationObserver(records=>records.forEach(r=>{
    if(r.type==='attributes') { if(ready.has(r.target)) load(r.target); }
    else r.addedNodes.forEach(n=>{if(n.nodeType===1) bind(n);});
  })).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['data-mp2-src']});
})();
